import { Component, OnInit, Input } from '@angular/core';

interface client {
  image: string;
};

@Component({
  selector: 'app-clients-logo',
  templateUrl: './clients-logo.component.html',
  styleUrls: ['./clients-logo.component.css']
})
export class ClientsLogoComponent implements OnInit {

  @Input() brand_class: string | undefined;
  /**
   * Clients Logo
   */
   clients_logo: client[] = [
    {
      image: "assets/images/solunes/icon-samsung.png"
    },
    {
      image: "assets/images/solunes/icon-honor.png"
    },
    {
      image: "assets/images/solunes/icon-skyworth.png"
    },
    {
      image: "assets/images/solunes/icon-tcl.png"
    },
    {
      image: "assets/images/solunes/icon-bolivar.png"
    },
    {
      image: "assets/images/solunes/libelula-logo.png"
    },
  ];

  constructor() { }

  ngOnInit(): void {
  }

}
